import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: `${API_URL}/admin`,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message || '';
    const isUnauthorized = status === 401;
    const isWrongUserType = status === 403 && message.includes('Access denied');
    if (isUnauthorized || isWrongUserType) {
      localStorage.removeItem('token');
      window.location.href = '/#/login';
    }
    return Promise.reject(error);
  }
);

export const adminService = {
  async getUsers(params) {
    const res = await api.get('/users', { params });
    return res.data;
  },
  async getPharmacies(params) {
    const res = await api.get('/pharmacies', { params });
    return res.data;
  },
  async getCustomers(params) {
    const res = await api.get('/customers', { params });
    return res.data;
  },
  async getRiders(params) {
    const res = await api.get('/riders', { params });
    return res.data;
  },
  async getOrders(params) {
    const res = await api.get('/orders', { params });
    return res.data;
  },
  async getPayments(params) {
    const res = await api.get('/payments', { params });
    return res.data;
  }
};

export default adminService;


